import React, { MouseEvent, useEffect, useState } from 'react'
import { copyToClipboard } from '../pgn'

interface CopyChipProps {
  label: string
  value: string
  title?: string
}

const CopyChip = ({ label, value, title }: CopyChipProps) => {
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    if (!copied) return undefined
    const timer = setTimeout(() => setCopied(false), 1200)
    return () => clearTimeout(timer)
  }, [copied])

  const handleClick = async (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    setCopied(await copyToClipboard(value))
  }

  return (
    <button
      className={`otree-chip ${copied ? 'is-copied' : ''}`}
      onClick={handleClick}
      title={title ?? `Copy ${label}`}
      type="button"
    >
      <span className="otree-chip-key">{label}</span>
      <span className="otree-chip-value">{value}</span>
      <span className="otree-chip-action">{copied ? 'copied' : 'copy'}</span>
    </button>
  )
}

export default CopyChip
